import styled from 'styled-components';

export const StyledInline = styled.div`
  display: inherit;
`;
